import { render, staticRenderFns } from "./XCardAction.vue?vue&type=template&id=e088839c"
import script from "./XCardAction.vue?vue&type=script&lang=js"
export * from "./XCardAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports